import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// /terminals/mdm → onglet « Parc MDM » de la page Terminaux ; /terminals/mdm?sn=XXX (lien vers un
// terminal précis) → liste des terminaux, dont le sn ouvre directement la fiche.
const MdmLegacyRedirect = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (!params.get('sn')) params.set('view', 'mdm');
  return <Navigate to={`/terminals?${params.toString()}`} replace />;
};

export default MdmLegacyRedirect;
